<template>
  <section v-if="slides.length" class="dealer-service-preview section-light">
    <div
      class="dealer-service-carousel"
      @mouseenter="stopCarousel"
      @mouseleave="startCarousel"
      @touchstart.passive="handleTouchStart"
      @touchend.passive="handleTouchEnd"
    >
      <button v-if="slides.length > 1" type="button" class="carousel-arrow carousel-arrow--left dealer-carousel__arrow" aria-label="Previous location type" @click="previous"><span aria-hidden="true"></span></button>
      <transition name="fade" mode="out-in">
        <DealerPreview
          :key="currentSlide.kind"
          :dealer="currentSlide.dealer"
          :section-id="currentSlide.sectionId"
          :kind="currentSlide.kind"
          :all-link="currentSlide.allLink"
        />
      </transition>
      <button v-if="slides.length > 1" type="button" class="carousel-arrow carousel-arrow--right dealer-carousel__arrow" aria-label="Next location type" @click="next"><span aria-hidden="true"></span></button>
      <div v-if="slides.length > 1" class="carousel-dots dealer-carousel__dots">
        <button v-for="(slide, dotIndex) in slides" :key="slide.kind" type="button" :class="{ active: dotIndex === index }" :aria-label="`Location type ${dotIndex + 1}`" @click="goTo(dotIndex)"></button>
      </div>
    </div>
  </section>
</template>

<script>
import DealerPreview from './DealerPreview.vue'

export default {
  name: 'DealerCarousel',
  components: { DealerPreview },
  props: {
    dealer: { type: Object, default: null },
    serviceProvider: { type: Object, default: null }
  },
  data () {
    return {
      index: 0,
      timer: null,
      touchStartX: 0
    }
  },
  computed: {
    // 只保留后台确实有数据的项：空的那一类不参与展示，也不参与轮播。
    // 只剩一项时不显示左右箭头和圆点（模板里已按 slides.length > 1 判断）。
    slides () {
      const items = []
      if (this.dealer) {
        items.push({
          kind: 'dealer',
          dealer: this.dealer,
          sectionId: 'dealers',
          allLink: '/dealers'
        })
      }
      if (this.serviceProvider) {
        items.push({
          kind: 'service',
          dealer: this.serviceProvider,
          sectionId: 'service-providers',
          allLink: '/service-providers'
        })
      }
      return items
    },
    currentSlide () { return this.slides[this.index] || this.slides[0] }
  },
  watch: {
    slides () {
      if (this.index >= this.slides.length) this.index = 0
      this.startCarousel()
    }
  },
  mounted () { this.startCarousel() },
  beforeDestroy () { this.stopCarousel() },
  methods: {
    next () { this.goTo((this.index + 1) % this.slides.length) },
    previous () { this.goTo((this.index - 1 + this.slides.length) % this.slides.length) },
    goTo (index) {
      this.index = index
      this.startCarousel()
    },
    startCarousel () {
      this.stopCarousel()
      if (this.slides.length > 1) this.timer = window.setInterval(this.next, 5000)
    },
    stopCarousel () {
      if (this.timer) window.clearInterval(this.timer)
      this.timer = null
    },
    handleTouchStart (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      this.touchStartX = touch ? touch.clientX : 0
    },
    handleTouchEnd (event) {
      const touch = event.changedTouches && event.changedTouches[0]
      if (!touch || !this.touchStartX) return
      const distance = touch.clientX - this.touchStartX
      this.touchStartX = 0
      if (Math.abs(distance) < 40) return
      if (distance < 0) this.next()
      else this.previous()
    }
  }
}
</script>
